import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './Badge.module.scss';

const Badge = ({ children, className }) => <span className={cx(styles.badge, className)}>{children}</span>;

Badge.defaultProps = {
	className: '',
};

Badge.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

export default Badge;
